import { Button, Form, Input, Modal } from 'antd'
import React, { useState } from 'react'
import { useEditMe } from '../../zustand/store';

function NameForm() {
    const [name, setName] = useState("");
    const editMe = useEditMe();


    return (
        <Modal footer open closable={false} centered>
            <Form layout='vertical' onFinish={() => editMe.execute({ data: { name } })}>
                <Form.Item label="What is your name?" name={"name"}>
                    <Input placeholder='Alex Smith' value={name} onChange={(e) => setName(e?.target?.value)} />
                </Form.Item>
                <Form.Item style={{ marginBottom: 0 }}>
                    <Button loading={editMe.loading} block type='primary' disabled={!name} htmlType='submit'>Save</Button>
                </Form.Item>
            </Form>
        </Modal>
    )
}

export default NameForm